import { DataField, Modal, Space, Text } from '@procurify/ui'

import { CopyToClipboardButton } from '@webapp/components/CopyToClipboardButton'
import { useProcurifyIntl } from '@webapp/hooks'
import { type FinancialAccountBankingDetails } from '@webapp/platform/banking/entities/FinancialAccountBankingDetails/FinancialAccountBankingDetails'
import { BankingDetailsLoader } from './components/BankingDetailsLoader'
import messages from './messages'
import { FinancialAccountBankingDetailsModalStyled } from './styles/FinancialAccountBankingDetailsModalStyled'
import { useFinancialAccountBankingDetails } from './useFinancialAccountBankingDetails'

export interface IFinancialAccountBankingDetailsModalProps {
  open: boolean
  accountDetails: FinancialAccountBankingDetails['fields']
  onClose: () => void
}

export const FinancialAccountBankingDetailsModal = ({
  open,
  accountDetails,
  onClose,
}: IFinancialAccountBankingDetailsModalProps) => {
  const intl = useProcurifyIntl()

  const {
    data: { fields },
    states: { showLoader },
  } = useFinancialAccountBankingDetails({ accountDetails })

  return (
    <Modal open={open} maxWidth='xs' onClose={onClose}>
      <Modal.Card>
        <Modal.Header onClose={onClose}>
          {intl.formatMessage(messages.modalHeader)}
        </Modal.Header>

        <Modal.Content>
          <FinancialAccountBankingDetailsModalStyled>
            <Space size='large'>
              <Text>{intl.formatMessage(messages.descriptionText)}</Text>

              <Space.Divider />

              <Space>
                <Space.Item width='min-content'>
                  <Space size='small'>
                    {showLoader ? (
                      <BankingDetailsLoader />
                    ) : (
                      fields.map((field) => (
                        <Space
                          key={field.label}
                          direction='horizontal'
                          justify='space-between'
                        >
                          <DataField label={field.label}>
                            {field.value}
                          </DataField>
                          <CopyToClipboardButton
                            value={field.value}
                            ariaLabel={intl.formatMessage(
                              messages.copyButtonLabel,
                              {
                                fieldLabel: field.label,
                              }
                            )}
                          />
                        </Space>
                      ))
                    )}
                  </Space>
                </Space.Item>
              </Space>
            </Space>
          </FinancialAccountBankingDetailsModalStyled>
        </Modal.Content>
      </Modal.Card>
    </Modal>
  )
}
